import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  spinner: {
    position: "absolute",
    left: "50%",
    marginLeft: "-10px"
  },
}));

export default styles;
